import { TicketSlider } from "components/Ticket/TicketSlider";
import { useState } from "react";
import { useChatContext } from "stream-chat-react";
import { TicketNotes } from "types/Models/chatTicket";
import { ModalProps } from "types/utils/modal";

export const TicketSliderFromHome = ({
  ticketId,
  isOpen,
  close,
}: ModalProps & {
  ticketId: string;
}) => {
  const { client: chatClient } = useChatContext();
  const [ticketNotesPage, setTicketNotesPage] = useState(1);
  const [ticketNotes, setTicketNotes] = useState<TicketNotes[]>([]);

  return (
    <TicketSlider
      resolvedStatus={false}
      openSlider={isOpen}
      setOpenSlider={close}
      ticketNotes={ticketNotes}
      setTicketNotes={setTicketNotes}
      ticketNotesPage={ticketNotesPage}
      setTicketNotesPage={setTicketNotesPage}
      chatClient={chatClient}
      isInsideGroup={false}
      ticketIdFromProps={ticketId}
    />
  );
};
